import localizationEnUsHeader from "./en-us/header.json";
import localizationEnUsMeta from "./en-us/meta.json";
import localizationEnUsSide from "./en-us/side.json";
import localizationEnUsMessage from "./en-us/message.json";

export const localizationEnUsKnowledgeBaseArticle = {
  ...localizationEnUsHeader,
  ...localizationEnUsMeta,
  ...localizationEnUsSide,
  ...localizationEnUsMessage,
};
